import { cva } from 'class-variance-authority'

/**
 * Knappens visuelle varianter.
 *
 * Ligger i sin egen fil, så `Button.tsx` kun eksporterer komponenter — ellers
 * kan Vites fast refresh ikke opdatere knappen uden at genindlæse siden.
 */
export const buttonVariants = cva(
  [
    'inline-flex items-center justify-center gap-2 whitespace-nowrap',
    'rounded-[var(--radius-control)] font-medium',
    'transition-[background-color,border-color,color,box-shadow,transform]',
    'duration-[var(--duration-hover)] ease-[var(--ease-out-soft)]',
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-400',
    'disabled:pointer-events-none disabled:opacity-50',
    '[&_svg]:pointer-events-none [&_svg]:shrink-0',
  ],
  {
    variants: {
      variant: {
        primary: [
          'bg-brand-500 text-white shadow-[0_6px_20px_rgb(118_87_255/0.28)]',
          'hover:bg-brand-400 active:bg-brand-600',
        ],
        secondary: [
          'border border-line-subtle bg-white/[0.05] text-text-primary',
          'hover:bg-white/[0.09] hover:border-line-strong',
        ],
        ghost: 'text-text-secondary hover:bg-white/[0.06] hover:text-text-primary',
        outline: [
          'border border-brand-500/50 bg-transparent text-brand-300',
          'hover:bg-brand-500/12 hover:border-brand-400',
        ],
        danger: 'bg-danger-500 text-white hover:bg-danger-400 active:bg-danger-500',
        link: 'text-brand-300 underline-offset-4 hover:underline hover:text-brand-200',
      },
      size: {
        // Højderne prioriterer informationsdensitet på desktop. På touch-flader
        // sikrer layoutet mindst 44 × 44 px.
        sm: 'h-8 px-3 text-[13px] [&_svg]:size-3.5',
        md: 'h-9.5 px-4 text-sm [&_svg]:size-4',
        lg: 'h-11 px-5 text-[15px] [&_svg]:size-4.5',
        icon: 'size-9.5 p-0 [&_svg]:size-4',
        'icon-sm': 'size-8 p-0 [&_svg]:size-3.5',
      },
    },
    defaultVariants: {
      variant: 'secondary',
      size: 'md',
    },
  },
)
